import { render, staticRenderFns } from "./onlineReserAdd.vue?vue&type=template&id=f36d8a86&scoped=true"
import script from "./onlineReserAdd.vue?vue&type=script&lang=js"
export * from "./onlineReserAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36d8a86",
  null
  
)

export default component.exports